import React, { memo } from 'react'
import { usePricingModal, PricingModalProps } from './usePricingModal'
import styles from './PricingModal.module.scss'
import Modal from '../Modal'
import RadioInput from 'components/RadioInput/RadioInput'
import { PricingPlans } from 'screens/Landing/Pricing/usePricing'

const PricingModal: React.FC<PricingModalProps> = (
  props: PricingModalProps
) => {
  const {
    title,
    plan,
    name,
    restaurantName,
    email,
    phone,
    isPoliciesAccepted,
    isLoading,
    isSubscribeSuccess,
    subscribeResponseMessage,
    setShowModal,
    setName,
    setRestaurantName,
    setEmail,
    setPhone,
    setIsPoliciesAccepted,
    handlePlanChange,
    onSubmit,
  } = usePricingModal(props)

  return (
    <form className={styles['pricing-form']} onSubmit={onSubmit}>
      <Modal
        title={title}
        btnSubmitLabel='Confirm'
        isBtnSubmitDisabled={isLoading}
        onClose={() => setShowModal(false)}
      >
        <div className={styles['radio-inputs']}>
          <RadioInput
            label='Free Forever'
            name='selectedPlan'
            icon='star'
            value={PricingPlans.FreePlan}
            isChecked={plan === PricingPlans.FreePlan}
            onChange={() => handlePlanChange(PricingPlans.FreePlan)}
          />
          <RadioInput
            label='Plus'
            name='selectedPlan'
            icon='star-fill'
            value={PricingPlans.PlusPlan}
            isChecked={plan === PricingPlans.PlusPlan}
            onChange={() => handlePlanChange(PricingPlans.PlusPlan)}
          />
          <RadioInput
            label='Pro'
            name='selectedPlan'
            icon='stars'
            value={PricingPlans.ProPlan}
            isChecked={plan === PricingPlans.ProPlan}
            onChange={() => handlePlanChange(PricingPlans.ProPlan)}
          />
        </div>

        <div className={`${styles['form-floating']} mb-3`}>
          <input
            type='text'
            className={`form-control ${styles['form-control']}`}
            id='name'
            name='name'
            value={name}
            placeholder='Name'
            onChange={(e) => setName(e.target.value)}
            autoComplete='off'
            required
          />
          <label htmlFor='name'>Your Name</label>
        </div>

        <div className={`${styles['form-floating']} mb-3`}>
          <input
            type='text'
            className={`form-control ${styles['form-control']}`}
            id='restaurantName'
            name='restaurantName'
            value={restaurantName}
            placeholder='Restaurant Name'
            onChange={(e) => setRestaurantName(e.target.value)}
            autoComplete='off'
            required
          />
          <label htmlFor='restaurantName'>Restaurant Name</label>
        </div>

        <div className={`${styles['form-floating']} mb-3`}>
          <input
            type='email'
            className={`form-control ${styles['form-control']}`}
            id='restaurantEmail'
            name='email'
            value={email}
            placeholder='Email Address'
            onChange={(e) => setEmail(e.target.value)}
            autoComplete='off'
            required
          />
          <label htmlFor='restaurantEmail'>Email Address</label>
        </div>

        <div className={`${styles['form-floating']} mb-3`}>
          <input
            type='tel'
            className={`form-control ${styles['form-control']}`}
            id='restaurantPhone'
            name='restaurantPhone'
            value={phone}
            placeholder='Phone'
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, '')
              setPhone(onlyNums)
            }}
            onBeforeInput={(
              e: React.FormEvent<HTMLInputElement> & InputEvent
            ) => {
              if (!/^[0-9]*$/.test(e.data || '')) {
                e.preventDefault()
              }
            }}
            autoComplete='off'
            required
          />
          <label htmlFor='restaurantPhone'>Phone</label>
        </div>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            name='policies'
            id='policies'
            className={`form-check-input ${styles['form-check-input']}`}
            checked={isPoliciesAccepted}
            onChange={(e) => setIsPoliciesAccepted(e.target.checked)}
            required
          />
          <label htmlFor='policies' className='form-check-label'>
            I have read and accept the{' '}
            <a href='/terms-and-conditions' target='_blank'>
              Terms and Conditions
            </a>{' '}
            and{' '}
            <a href='/privacy-policy' target='_blank'>
              Privacy Policy
            </a>
          </label>
        </div>

        <div className='my-3'>
          <div
            className={styles.loading}
            style={{ display: isLoading ? 'block' : 'none' }}
          ></div>
          <div
            className={styles['error-message']}
            style={{
              display: isSubscribeSuccess === false ? 'block' : 'none',
            }}
          >
            {subscribeResponseMessage}
          </div>
          <div
            className={styles['sent-message']}
            style={{
              display: isSubscribeSuccess ? 'block' : 'none',
            }}
          >
            {subscribeResponseMessage}
          </div>
        </div>
      </Modal>
    </form>
  )
}

export default memo(PricingModal)
